import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left rail — brand */}
      <aside className="hidden md:flex md:w-[42%] flex-col justify-between p-12 text-paper" style={{ background: "#AD393E" }}>
        <div className="wordmark text-paper text-sm">
          <span>RESILIENT</span> <span style={{ color: "#D8E9EF" }}>TEAMS</span>
        </div>
        <div>
          <h1 className="text-paper" style={{ fontSize: "clamp(2.75rem, 5vw, 4rem)", lineHeight: 1.02, marginBottom: "2rem", color: "#FBFAF7" }}>
            The work begins<br />before the data.
          </h1>
          <p className="lead text-paper max-w-md" style={{ color: "#FAF7F1", opacity: 0.92 }}>
            Sign in to set up an assessment, review responses, and prepare findings for client conversation.
          </p>
        </div>
        <div className="text-paper text-xs uppercase tracking-widest" style={{ fontFamily: "Oswald", letterSpacing: "0.25em", color: "#FAF7F1" }}>
          Intent Consulting · ORI Platform
        </div>
      </aside>

      {/* Right side — form */}
      <main id="main-content" className="flex-1 flex items-center justify-center p-8 bg-paper">
        <div className="w-full max-w-sm">
          <div className="md:hidden mb-10">
            <div className="wordmark text-sm">
              <span style={{ color: "#1A1A1A" }}>RESILIENT</span> <span style={{ color: "#2F6B7C" }}>TEAMS</span>
            </div>
          </div>
          <div className="eyebrow mb-3">Consultant console</div>
          <h2 style={{ fontSize: "2.25rem", marginBottom: "0.5rem" }}>Sign in</h2>
          <p className="lead text-base mb-10" style={{ color: "#555555" }}>
            Consultants and platform administrators only. Clients do not log in.
          </p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="field"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="label" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="field"
                data-testid="login-password-input"
              />
            </div>
            {error && (
              <div className="text-sm py-2 px-3" style={{ color: "#AD393E", background: "#FBFAF7", border: "1px solid #AD393E" }} data-testid="login-error">
                {error}
              </div>
            )}
            <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="login-submit-button">
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <p className="mt-10 text-xs text-neutral leading-relaxed" style={{ color: "#6F6F6F" }}>
            Resilient Teams · ORI consultant console. Production stack: FastAPI + React + MongoDB Atlas.
          </p>
        </div>
      </main>
    </div>
  );
}
